import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import request from "./utils/request.js"
import storage from "./utils/storage.js"
Vue.prototype.$storeage = storage

import '@/assets/css/global.css'

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
	router,
	request,
	el: '#app',
	render: h => h(App)
});